import {Component, EventEmitter, Input, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {DecisionGridEvictionService} from '../../Services/decision-grid-eviction.service';
import {UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {EvictionSettingModel, OverrideModel} from '../../Models/criminal-model';
import {ClientService} from '../../../clients-module/services/client.service';
import {ToastrService} from 'ngx-toastr';
import * as _ from 'lodash';
import {ObjectUpdatePayload} from '../../../models/screeningInvite';
import {AuthService} from '../../../services/auth.service';
import { Subscription } from 'rxjs';
import { GroupService } from '../../Services/groups.service';

@Component({
  selector: 'app-criminal-grid-evictions',
  templateUrl: './criminal-grid-evictions.component.html',
  styleUrls: ['./criminal-grid-evictions.component.less'],
  encapsulation: ViewEncapsulation.None,
})
export class CriminalGridEvictionsComponent implements OnInit, OnDestroy {

  public form: UntypedFormGroup;
  @Input() reset: EventEmitter<any>;
  private reset$: Subscription;

  constructor(
    private readonly decisionGridEvictionService: DecisionGridEvictionService,
    private readonly formBuilder: UntypedFormBuilder,
    private readonly clientService: ClientService,
    private readonly toast: ToastrService,
    private readonly auth: AuthService,
    public readonly groupService: GroupService,
  ) {
  }
  ngOnDestroy(): void {
    if(this.reset$) this.reset$.unsubscribe();
  }

  public ngOnInit(): void {

    this.createForm();
  }

  public createForm() {

    this.form = this.formBuilder.group({
      evictions: this.formBuilder.array([])
    });

    this.decisionGridEvictionService.evictionSettingsSubscription$.subscribe((r: EvictionSettingModel[]) => {

      const f = <UntypedFormArray>this.form.controls.evictions;
      // Clear all existing
      f.clear();

      r.forEach((q: EvictionSettingModel) => {

        q.isOverride = q.groupId > 0;

        f.push(new UntypedFormGroup({
          howManyAllowed: new UntypedFormControl(q.howManyAllowed, [Validators.required]),
          howLong: new UntypedFormControl(q.howLong, [Validators.required]),
          decision: new UntypedFormControl(q.decision, [Validators.required]),
          chargeType: new UntypedFormControl(q.chargeType, [Validators.required]),
          settingId: new UntypedFormControl(q.settingId, [Validators.required]),
          clientId: new UntypedFormControl(q.clientId, [Validators.required]),
          groupId: new UntypedFormControl(q.groupId),
          isOverride: new UntypedFormControl(q.isOverride)
        }));
      });

      // console.log('EVICTONS ETTING DATA: ', f);
    });
  }

  public track(item: any, index: number) {
    return index;
  }

  public get EvictionSettings() : EvictionSettingModel[] {
    if(this.form.get('evictions')['controls']) return this.form.get('evictions')['controls']
    else return [];
  }

  public newSetting(): void {
    const f = <UntypedFormArray>this.form.controls.evictions;

    // First, check the last one in. If that setting is invalid, do not allow them to add another one.

    f.push(new UntypedFormGroup({
      howManyAllowed: new UntypedFormControl(null, [Validators.required]),
      howLong: new UntypedFormControl(null, [Validators.required]),
      decision: new UntypedFormControl(null, [Validators.required]),
      chargeType: new UntypedFormControl(0, [Validators.required]),
      settingId: new UntypedFormControl(0, [Validators.required]),
      clientId: new UntypedFormControl(this.clientService.currentClient.id, [Validators.required]),
    }));
  }

  public saveEvictionSetting(index: number): void {
    const f = <UntypedFormArray>this.form.controls.evictions;

    if (!f.controls[index].valid) {
      this.toast.warning('Eviction setting has errors. Please correct', 'Setting Invalid');
    }

    const settingId = f.controls[index].get('settingId').value;

    const formValue = f.controls[index].value;

    if (settingId > 0) {
      // This is an edit
      this.decisionGridEvictionService.updateEvictionSetting(this.clientService.currentClient.id, formValue).subscribe((r: any) => {
        this.toast.success('Eviction setting successful modified', 'Save Successful');
        f.controls[index].markAsPristine();
        f.controls[index].markAsUntouched();
      });

    } else {
      // This is a new one
      this.decisionGridEvictionService.insertEvictionSetting(this.clientService.currentClient.id, formValue).subscribe((r: EvictionSettingModel) => {
        this.toast.success('Eviction setting successful added', 'Save Successful');
        f.controls[index].markAsPristine();
        f.controls[index].markAsUntouched();

        f.controls[index].get('settingId').setValue(r.settingId);
      });
    }
  }

  public deleteEvictionSetting(index: number): void {

    const f = <UntypedFormArray>this.form.controls.evictions;
    const settingId = f.controls[index].get('settingId').value;

    this.decisionGridEvictionService.deleteEvictionSetting(this.clientService.currentClient.id, settingId).subscribe((r: any) => {
      // remove this from the array
      f.removeAt(index);
      this.toast.success('Eviction setting Successful removed', 'Save Successful');
    });
  }

  public cancelEvictionSetting(index: number): void {

    const f = <UntypedFormArray>this.form.controls.evictions;

    // First get the original settings
    const originalSetting = this.decisionGridEvictionService.evictionSettings.find(w => w.settingId === f.controls[index].get('settingId').value);

    f.controls[index].reset(originalSetting);
  }


  public isFormDirty(): boolean {
    return this.form.controls?.howManyAllowed?.dirty ||
      this.form.controls?.howLong?.dirty ||
      this.form.controls?.decision?.dirty;
  }

  public propertyOverride(e: EvictionSettingModel): void {
    console.log(e);
    let item = new EvictionSettingModel();
    const f = <UntypedFormArray>this.form.controls.evictions;

    if (e) {
      item = e;
    }

    const rowData = this.formBuilder.group({
      id: 0,
      clientId: [this.clientService.currentClient.id, Validators.required],
      userId: [this.auth.loggedInUser.id, Validators.required],
      groupId: [item.groupId, Validators.required],
      howManyAllowed: [0, Validators.required],
      howLong: [0, Validators.required],
      decision: [item.decision, Validators.required],
      isOverride: [true],
      settingId: [0]
    });

    f.push(rowData);
  }
}

